import React, { useEffect, useState, useCallback } from 'react';
import { Row, Col, Accordion, Card, InputGroup, FormControl, useAccordionButton } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// redux
import { useSelector } from 'react-redux';
import { companySelector } from 'slices/company';
// icons
import { BiSearch } from 'react-icons/bi';
import { FaPlus, FaMinus } from "react-icons/fa";
import { PiBroomBold } from "react-icons/pi";
// images
import FaqsImg from 'assets/img/img_faqs.png';
// api
import { getAllFaqs } from 'api/faqs';
// components
import SectionLoader from 'components/loader/SectionLoader';
import Pagination from 'components/userzone/Pagination';
import NoResults from 'components/userzone/NoResults';
import Head from 'components/metatags_helmet/metatags';
import TitleWithLine from 'components/titleWithLine';
import './infoPages.scss';

const Faqs = () => {
  const { t } = useTranslation(['backoffice']);
  const [activeKey, setActiveKey] = useState();
  const [langSelected, setLangSelected] = useState('es');
  const { descripcion_pub, languages } = useSelector(companySelector);
  const [inputValue, setInputValue] = useState('');
  const [timer, setTimer] = useState(null);
  //pagination
  const [isLoading, setIsLoading] = useState(true);
  const [maxPage, setMaxPage] = useState(null);
  const [page, setPage] = useState(1);
  const [faqs, setFaqs] = useState([]);
  const [noResults, setNoResults] = useState(false);

  const CustomToggle = ({ children, eventKey }) => {
    const decoratedOnClick = useAccordionButton(eventKey);

    return (
      <button
        type="button"
        onClick={decoratedOnClick}
      >
        {children}
      </button>
    );
  };

  const getFaqs = async (value = null) => {
    setIsLoading(true);
    const { data, status } = await getAllFaqs({
      active: true,
      page,
      page_size: 10,
      query: inputValue,
      search: value !== null ? value : inputValue
    });

    if (status === 200) {
      const results = data?.results.sort((a, b) => a.order - b.order);
      setFaqs(results)
      setMaxPage(data?.total_pages);
      setIsLoading(false);
      setNoResults(data?.results.length <= 0)
    }
  };

  const handleClear = () => {
    const newFaqs = {};
    setInputValue('');
    setPage(1);
    setNoResults(false);
    getFaqs(newFaqs);
    document.getElementById('input-search').value = '';
  };

  const searchText = useCallback(
    (e) => {
      const value = e.target.value
      setInputValue(value);
      if (timer) {
        clearTimeout(timer);
      }
      setTimer(
        setTimeout(() => {
          setPage(1);
          getFaqs(value);
        }, 500),
      );
    },
    [inputValue],
  );

  useEffect(() => {
    getFaqs();
  }, [page]);

  useEffect(() => {
    const lang = localStorage.getItem('i18nextLng');
    if (languages.some((element) => element.code_iso2.includes(lang)))
      setLangSelected(lang);
  }, [localStorage.getItem('i18nextLng')]);

  return (
    <div className="container-fluid px-0 mainDiv faqs">
      <Head description={descripcion_pub} title={t('faqs.faqsTitle')} noIndex={true} />
      <Row className="infoRow">
        <Col md={8} xs={10} className="mt-4 pl-0">
          <Row>
            <Col md={12}>
              <TitleWithLine text={t('faqs.faqsTitle')} />
            </Col>
          </Row>
          <Row>
            <Col md={11}>
              <form action="" method="get">
                <div className="form-group has-feedback has-search">
                  <i className="fas fa-search form-control-feedback"></i>
                  <InputGroup className="mb-3">
                    <FormControl
                      id='input-search'
                      type="text"
                      value={inputValue}
                      placeholder={t('faqs.faqsPlaceholder')}
                      onInput={(e) => {
                        searchText(e);
                      }}
                    />
                    <InputGroup.Text>
                      <BiSearch />
                    </InputGroup.Text>
                  </InputGroup>
                </div>
              </form>
            </Col>
            <Col md={1} className='close-search'>
              <PiBroomBold onClick={handleClear} title={t('faqs.cleanSearch')} />
            </Col>
          </Row>
          {!noResults ? <>
            {!isLoading && faqs.map((faq, index) => {
              const faqNumber = (page - 1) * 10 + (index + 1);
              return <Row key={`faq_${index}`}>
                <Col md={12}>
                  <Accordion className='faqs-accordion' activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                    <Card>
                      <Card.Header>
                        <p className='question'>{`${faqNumber}. ${faq[`question_${langSelected}`]}`}</p>
                        <CustomToggle eventKey={index}>
                          {activeKey === index ? <FaMinus /> : <FaPlus />}
                        </CustomToggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey={index}>
                        <Card.Body>
                          <p dangerouslySetInnerHTML={{ __html: faq[`answer_${langSelected}`] }} />
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </Col>
              </Row>
            })}
            {isLoading && <SectionLoader />}
            {!isLoading && <Row>
              <Col md={12}>
                <Pagination changePage={setPage} page={page} totalPages={maxPage} />
              </Col>
            </Row>}
          </> : <NoResults className='noFavorites' />}
        </Col>
        <Col md={2} xs={12} className="d-flex justify-content-center align-items-start mt-4 pr-0 pt-lg-4">
          <img src={FaqsImg} alt="faqs.png" className="infoImg" />
        </Col>
      </Row>
    </div>
  );
};

export default Faqs;
